/**
 * media에 currentTime을 직접 set할 때 사용하는 함수.
 * 특정 구 브라우저들은 metadata가 없는 경우에 set currentTime을 하게되면 브라우저에서 DOM Exception이 나서 페이지 자체가 에러페이지로 넘어가버린다.
 * 해당 상황을 회피하기 위해 방어로직이 포함되어있는 함수이다.
 */
export function setMediaCurrentTime(
  mediaElement: HTMLVideoElement | HTMLAudioElement,
  currentTime: number
) {
  // mediaElement를 필수값으로 받았지만, 혹시나 없으면 에러를 내므로 방어코드를 추가함
  if (!mediaElement || currentTime === undefined) {
    return;
  }
  // metadata가 로딩되지 않은 상황에 currentTime 조작시에 오래된 브라우저에서 에러가 나는 경우가 종종 있다. duration 정보가 없다는 건 currentTime도 set할 수 없다는 이야기이므로 Early return한다.
  if (!mediaElement.duration) {
    return;
  }
  mediaElement.currentTime = currentTime;
}
